import React, { useEffect, useState } from 'react';
import { apiGet, apiPost } from '../../api';
import { toast } from 'react-toastify';

const UpdateProfile = () => {
  const [profile, setProfile] = useState({ name: '', email: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await apiGet('/api/admin/account/profile');
        if (res.data.success) {
          setProfile({ name: res.data.data.name, email: res.data.data.email });
        } else {
          toast.error(res.data.message || 'Failed to fetch profile');
        }
      } catch (err) {
        if (err.response?.data?.message) {
          toast.error(err.response.data.message);
        } else if (err.response?.data?.error) {
          toast.error(err.response.data.error);
        } else if (err.message) {
          toast.error(err.message);
        } else {
          toast.error('Failed to fetch profile');
        }
      }
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await apiPost('/api/admin/account/profile/update-profile', profile);
      if (response.data.success) {
        toast.success(response.data.message || 'Profile updated successfully');
      } else {
        toast.error(response.data.message || 'Failed to update profile');
      }
    } catch (err) {
      if (err.response?.data?.message) {
        toast.error(err.response.data.message);
      } else if (err.response?.data?.error) {
        toast.error(err.response.data.error);
      } else if (err.message) {
        toast.error(err.message);
      } else {
        toast.error('Failed to update profile');
      }
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-md border border-border/70 bg-white/[0.03] px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30";
  const labelCls = "block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5";

  return (
    <div className="max-w-lg mx-auto">
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">
        <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
        Management
      </div>
      <h1 className="font-serif italic text-[45px] leading-[1.02] text-foreground mb-1">
        Update <span className="text-gradient-ginox">Profile</span>
      </h1>
      <p className="text-sm text-muted-foreground mb-6">
        Manage your account information
      </p>

      <div className="border-t border-white/[0.08] pt-6">
        <h2 className="text-[10px] font-medium uppercase tracking-[1.5px] text-muted-foreground/60 mb-5">
          Profile Details
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className={labelCls}>Name</label>
            <input
              type="text"
              name="name"
              value={profile.name}
              onChange={handleChange}
              className={inputCls}
              required
            />
          </div>
          <div>
            <label className={labelCls}>Email</label>
            <input
              type="email"
              name="email"
              value={profile.email}
              onChange={handleChange}
              className={inputCls}
              required
            />
          </div>
          <div className="pt-2">
            <button
              type="submit"
              disabled={loading}
              className="rounded-md border border-ginox-green/60 bg-ginox-green/10 px-4 py-2 text-xs font-medium text-ginox-green hover:bg-ginox-green/20 transition-colors disabled:opacity-50"
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateProfile;
